export default "__VITE_PUBLIC_ASSET__ca2c6251__"